import { createAction } from '@wix/communities-blog-client-common';
import { addModalToRegistry, resolveModalInRegistry } from './opened-modals-promise-registry';

export const OPEN_MODAL = 'modal/OPEN';
export const CLOSE_MODAL = 'modal/CLOSE';

export const openModal = createAction(
  OPEN_MODAL,
  (type: any, props?: any, _meta?: any, correlationId?: any) => ({ type, props, correlationId }),
  (_type: any, _props?: any, meta?: any) => meta,
);
export const closeModal = createAction(CLOSE_MODAL, (payload: any) => payload);

// wrapper for component side
export const withPromisifiedOpenModal = (openModal: any) => (type: any, props: any, meta: any) => {
  const { correlationId, promise } = addModalToRegistry();
  openModal(type, props, meta, correlationId);
  return promise;
};

// wrapper for component side
export const withPromisifiedCloseModal = (closeModal: any) => (props: any) => {
  resolveModalInRegistry(props.correlationId, props.resolve);
  return closeModal(props);
};
